<template>
  <div v-if="!loading">
    <div>
      <div class="flex justify-between">
        <h4 class="text-1lg">Users</h4>
        <button
          class="text-1md text-yellow-500"
          @click="onOpenInvitationModal"
        >
          Invite New User +
        </button>
      </div>
      <div class="mt-4 max-w-lg rounded-md border border-light-gray">
        <div
          v-for="(user, index) in companyUsers"
          :key="user.id"
        >
          <company-user-card
            :user="user"
            :class="index !== companyUsers.length ? 'border-b' : ''"
            :dark-bg="index % 2 !== 0"
            :toggle-delete-modal-on="toggleDeleteModalOn"
          />
        </div>
      </div>
      <section class="flex w-full items-center justify-center px-4 py-2">
        <pagination
          :selected-page="parseInt(pagination.currentPage)"
          :total-pages="parseInt(pagination.totalPages)"
          equivalent
          :pages-around="counterPageAround(pagination.totalPages)"
          @select-page="handlePage"
        />
      </section>
    </div>
  </div>
  <div
    v-else
    class="tablet-desktop-container mx-auto flex h-80 max-w-2xl items-center justify-center pt-12 sm:overflow-scroll md:overflow-hidden"
  >
    <img
      class="-top-2px loading relative h-12 w-full"
      src="@/assets/loading-v2-yellow.svg"
      alt=""
    />
  </div>
  <user-invitation-modal
    v-if="invitationModalVisible"
    :visible="invitationModalVisible"
    type="accept"
    @close="onCloseInvitationModal"
    @invitation-sent="onCloseSentInvitationModal"
  />
  <confirm-delete-modal
    :visible="deleteModal"
    subtext="Are you sure you want to delete this user? This action cannot be undone."
    @delete="handleDeleteUser"
    @close="toggleDeleteModalOff"
  />
</template>

<script type="text/javascript">
import CompanyUserCard from '@/components/carrier/Cards/CompanyUserCard.vue';
import UserInvitationModal from '@/components/modals/UserInvitationModal.vue';
import ConfirmDeleteModal from '@/components/modals/ConfirmDeleteModal.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'Users Mobile Index',
  components: {
    CompanyUserCard,
    UserInvitationModal,
    ConfirmDeleteModal,
    Pagination,
  },
  data() {
    return {
      invitationModalVisible: false,
      deleteModal: false,
      userId: '',
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.users.currentUser;
    },
    companyUsers() {
      return this.$store.state.users.companyUsers;
    },
    loading() {
      return this.$store.state.loading.isLoading;
    },
    pagination() {
      return this.$store.state.users?.companyUsersPagination;
    },
  },
  watch: {
    '$store.state.users.companyUsers': function (val) {
      if (Object.keys(val).length > 0) {
        this.$store.commit('loading/loadingToggleOff', null, {
          root: true,
        });
      }
    },
  },
  async created() {
    this.$store.commit('loading/loadingToggleOn', null, {
      root: true,
    });
    const body = {
      companyId: this.$store.state.users.currentUser.company.id,
      perPage: 50,
    };
    await this.$store.dispatch('users/getCompanyUsers', body);
  },
  methods: {
    async handlePage(newCurrentPage) {
      await this.$store.dispatch('users/getCompanyUsers', {
        page: newCurrentPage,
        perPage: 50,
        companyId: this.currentUser.company.id,
      });
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    counterPageAround(pages) {
      const NumberOfPages = parseInt(pages);
      if (NumberOfPages > 5) {
        return 2;
      } else {
        return NumberOfPages;
      }
    },
    onOpenInvitationModal() {
      this.invitationModalVisible = true;
    },
    async handleDeleteUser() {
      await this.$store.dispatch('users/deleteUser', this.userId);
      this.toggleDeleteModalOff();
    },
    toggleDeleteModalOn(id) {
      this.userId = id;
      this.deleteModal = true;
    },
    toggleDeleteModalOff() {
      this.deleteModal = false;
    },
    onCloseInvitationModal() {
      this.invitationModalVisible = false;
    },
    onCloseSentInvitationModal() {
      this.invitationModalVisible = false;
      this.$toast.open({
        message: 'Invite sent',
        type: 'success',
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      });
    },
  },
};
</script>
